const RESERVED_USERNAMES = new Set([
    'admin', 'administrator', 'administrador', 'adm', 'adm1n', '4dmin',
    'root', 'superadmin', 'superuser', 'sysadmin', 'system',
    'gm', 'gamemaster', 'moderator', 'moderador', 'mod',
    'staff', 'support', 'suporte', 'helpdesk', 'atendimento',
    'dev', 'developer', 'desenvolvedor', 'owner', 'dono',
    'webmaster', 'operator', 'operador', 'master', 'server',
    'knightadmin', 'icarusadmin', 'serveradmin', 'painel', 'panel',
]);

const ADMIN_LIKE_PATTERN = /admin|adm1n|4dmin|superadmin|administrador|administrator/i;

export function normalizeUsername(username: string): string {
    return username.trim();
}

export function isReservedUsername(username: string): boolean {
    const normalized = normalizeUsername(username);
    if (normalized.length < 3) return false;

    const lower = normalized.toLowerCase();
    if (RESERVED_USERNAMES.has(lower)) return true;
    if (ADMIN_LIKE_PATTERN.test(normalized)) return true;
    if (lower.startsWith('admin') || lower.endsWith('admin')) return true;

    return false;
}
